package horcrux.common.extensions

import arrow.fx.coroutines.parMap
import kotlinx.coroutines.CoroutineScope
import kotlin.coroutines.CoroutineContext
import kotlin.coroutines.EmptyCoroutineContext

suspend fun <A, B, C : Iterable<B>> Iterable<A>.parMap(
    context: CoroutineContext = EmptyCoroutineContext,
    transform: suspend CoroutineScope.(A) -> B,
    resultTransform: (List<B>) -> C = { it as C },
): C =
    this.toList().parMap(context, transform).let(resultTransform)

suspend fun <A, B, C, D> Map<A, B>.parMap(
    context: CoroutineContext = EmptyCoroutineContext,
    transform: suspend CoroutineScope.(A, B) -> Pair<C, D>,
): Map<C, D> =
    this.toList().parMap(context) { pair ->
        transform(pair.first, pair.second)
    }.toMap()
